import { Api } from "../../Api";

export const getNFTDetailsService = async (nftId: string | undefined) => {
  let url = `nft/nft-detail/${nftId}`;
  const response = await Api.get(url);
  return response;
};

export const getWalletAddressService = async () => {
  let url = `nft/get-admin-address`;
  const response = await Api.get(url);
  return response;
};
interface postData {
  nftId: string;
}
export const markedAsSold = async (nftId: postData) => {
  let url = `nft/mark-nft-sold`;
  const response = await Api.post(url, nftId);
  return response;
};
